import styled from 'styled-components';

import { Title } from 'components';

const HeaderText = styled(Title)`
  && {
    margin-bottom: 4px;
    font-size: 14px;
  }
`;

export default HeaderText;
